import React from 'react'

const PrimaryListWrapper = ({ children }) => (
  <div className="listPrimary">
    {children}
  </div>
)

export default PrimaryListWrapper


// WEBPACK FOOTER //
// ./src/ui/list/views/primary-list-wrapper.jsx